import { render } from "./reset.vue?vue&type=template&id=02193542"
import script from "./reset.vue?vue&type=script&lang=js"
export * from "./reset.vue?vue&type=script&lang=js"

import "./reset.vue?vue&type=style&index=0&id=02193542&lang=less"
script.render = render

export default script